
const texts = {
    errorMessages: {
      rechazo:'EF003: No se pudo completar la acción. Probá de nuevo en unos minutos. Si sigue el problema, escribí a soporte.',
      networkError: 'EF001: Hubo un error de conexión con el servidor. Probá otra vez en unos minutos.',
      obtenerEstadoFirma: 'EF0028: Hubo un error al verificar el estado de la firma. Probá otra vez en unos minutos. Si el error sigue, escribí a soporte.',
      noFirma:'EF0029: Hubo un error en la firma digital. Acordate que para firmar necesitás tener instalada la aplicación “Firmador Digital PJM”.',
      obtenerEstadoDoc:'EF0030: Hubo un error al verificar el estado del documento. Probá de nuevo en unos minutos. Si el error sigue, escribí a soporte.',
      firmador:'EF0031: Hubo un problema al firmar el documento. Para firmar, necesitás tener instalada la aplicación “Firmador Digital PJM” en tu computadora.',
      firmarDigitalmente:'EF0032: No se puede firmar desde celular o tablet. Debés usar una computadora con la aplicación “Firmador Digital PJM” instalada.',
      peticionTardo:'EF002: El servidor no respondió. Probá de nuevo en unos minutos. Si el problema sigue, escribí a soporte.',
    },
    signStatus:{
      exito: 'El documento se firmó correctamente.',
      vencido: 'El documento ya no está vigente.',
      proceso: 'El proceso de firma todavía no terminó.',
      firmado: 'Ya firmaste este documento.',
    },
    buttons: {
      denegar: 'Rechazar',
      cancel:'Cancelar',
      clean: 'Borrar contenido',
      save: 'Guardar cambios',
      confirmar: 'Aceptar',
      dowload: 'Descargar archivo',
    },
  };
  
  export default texts;
  